/**
 * Custom request response header values
 */
export enum RequestResponseHeaderEnum {
	REQUEST_ID = 'x-um-request-id',
	TENANT_ORG_ID = 'x-um-tenant-org-id',
	TENANT_ID = 'x-um-tenant-id',
	TIMEZONE = 'x-um-timezone',
	WEBSOCKET_SOCKET_ID = 'x-um-websocket-socket-id',
	WEBSOCKET_EXCLUDE_SUBSCRIPTION_ID = 'x-um-websocket-exclude-subscription-id',
}
